import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0172317a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "elem-specs",
  "dark-class": "elem-specs-dark"
}
const _hoisted_2 = { class: "group-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "规格种类：", -1))
const _hoisted_4 = { class: "group-actions" }
const _hoisted_5 = { class: "spec-table" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"table-header\" data-v-0172317a><div class=\"col title\" data-v-0172317a>名称</div><div class=\"col stock\" data-v-0172317a>库存</div><div class=\"col price\" data-v-0172317a>加价(元)</div><div class=\"col weight\" data-v-0172317a>加重量(克)</div><div class=\"col points\" data-v-0172317a>加积分</div><div class=\"col action\" data-v-0172317a>操作</div></div>", 1)
const _hoisted_7 = { class: "table-body" }
const _hoisted_8 = { class: "col title" }
const _hoisted_9 = { class: "col stock" }
const _hoisted_10 = { class: "col price" }
const _hoisted_11 = { class: "col weight" }
const _hoisted_12 = { class: "col points" }
const _hoisted_13 = { class: "col action" }
const _hoisted_14 = { class: "table-footer" }
const _hoisted_15 = {
  key: 0,
  class: "footer"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-text" }, "暂无规格配置", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-desc" }, "点击此处添加第一个规格组，如“颜色”、“尺寸”等", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_input_object = _resolveComponent("elem-input-object")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_elem_input_object, {
      name: _ctx.name,
      getValue: _ctx.getValue
    }, null, 8, ["name", "getValue"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group, gIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "spec-group",
        key: gIndex
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Input, {
            modelValue: group.category,
            "onUpdate:modelValue": ($event: any) => ((group.category) = $event),
            placeholder: "如: 颜色、尺寸",
            style: {"width":"200px"}
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              type: "text",
              icon: "md-trash",
              class: "btn-delete-group",
              onClick: ($event: any) => (_ctx.removeGroup(gIndex))
            }, {
              default: _withCtx(() => [
                _createTextVNode("删除该组")
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item, iIndex) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "table-row",
                key: iIndex
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Input, {
                    class: "input",
                    modelValue: item.title,
                    "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                    placeholder: "如: 红色"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Input, {
                    class: "input",
                    modelValue: item.stock,
                    "onUpdate:modelValue": ($event: any) => ((item.stock) = $event),
                    type: "number",
                    min: 0,
                    placeholder: "0",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Input, {
                    class: "input",
                    modelValue: item.price,
                    "onUpdate:modelValue": ($event: any) => ((item.price) = $event),
                    type: "number",
                    min: 0,
                    step: 0.01,
                    placeholder: "0.00",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_Input, {
                    class: "input",
                    modelValue: item.weight,
                    "onUpdate:modelValue": ($event: any) => ((item.weight) = $event),
                    type: "number",
                    min: 0,
                    placeholder: "0",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Input, {
                    class: "input",
                    modelValue: item.points,
                    "onUpdate:modelValue": ($event: any) => ((item.points) = $event),
                    type: "number",
                    min: 0,
                    placeholder: "0",
                    style: {"width":"100%"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_Button, {
                    type: "text",
                    icon: "md-trash",
                    class: "btn-delete",
                    onClick: ($event: any) => (_ctx.removeItem(gIndex, iIndex)),
                    size: "small"
                  }, null, 8, ["onClick"])
                ])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_Button, {
                type: "dashed",
                size: "small",
                icon: "md-add",
                onClick: ($event: any) => (_ctx.addItem(gIndex))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("添加规格值")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ])
        ])
      ]))
    }), 128)),
    (_ctx.groups.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_Button, {
            type: "primary",
            ghost: "",
            long: "",
            icon: "md-add",
            onClick: _ctx.addGroup
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加新规格组")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.groups.length === 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "empty",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addGroup && _ctx.addGroup(...args)))
        }, [
          _createVNode(_component_Icon, {
            type: "ios-apps-outline",
            size: "52",
            class: "empty-icon"
          }),
          _hoisted_16,
          _hoisted_17
        ]))
      : _createCommentVNode("", true)
  ]))
}